export const environment = {
  api: 'https://api.mbtaoutreach.com/api',
  identity: 'https://accounts.mbtaoutreach.com',
  production: true,
  clientLogo: './assets/logos/mbta-logo.png',
  clientFavicon: './assets/logos/mbta-favicon.png',
};
